//import {test_function} from "./../functions/test_function.js";




import { SmetioSetUpAndInitialization } from "../../smetioSetUpAndInitialization/v1.0.0/SmetioSetUpAndInitialization.js";


export class SmetioCustomerWebsiteSection extends SmetioSetUpAndInitialization {

    constructor(data = {}) {

        super(data);

        this.setId();
    
        // this.sectionId = "#smetio-template-locations";
        this.publicAccessToken = data.publicAccessToken;

        // console.log("++++++++++++++++++++++++++++++ this.publicAccessToken is ", this.publicAccessToken);
            
        this.filters = {
            limit: 100,
            orderBy: "createdOn DESC",
            offset: 0,
            country: "",
            city: "",
            tags: "",
            smetioBnac: this.smetioBnac
        };

        this.itemsPerSection = 10;
        this.totalNumberOfData = null;

        this.sectionHeadingClass = "smetio-customer-website-section-heading-" + this.id;
        this.sectionHeadingAttributes = {
            class: ["smetio-customer-website-section-heading", this.sectionHeadingClass],
        };

    

        this.searchBtnClass = "smetio-customer-website-search-view-btn-" + this.id;
        this.searchBtnAttributes = {
            class: ["smetio-customer-website-btn", "smetio-customer-website-search-view-btn", this.searchBtnClass],
        };

        this.filterBtnClass = "smetio-customer-website-filter-view-btn-" + this.id;
        this.filterBtnAttributes = {
            class: ["smetio-customer-website-btn", "smetio-customer-website-filter-view-btn", this.filterBtnClass],
        };
    };


    simplePreloader() {

        return`
            <div class="smetio-customer-website-section-preloader smetio-fullW-fullH smetio-flex-column-perfect-center smetio-text-center">
                <i class=" smetio-icon smetio-icon-spinner2 smetio-icon-spinning "></i>
            </div>
        `;

    };

    getSearchAndFilterBtn(){
        return `
            <div ${this.getAttributes(this.filterBtnAttributes, false)} >
                <i class="smetio-icon smetio-icon-filter1"></i>
            </div>    

            <div ${this.getAttributes(this.searchBtnAttributes, false)} >
                <i class="smetio-icon smetio-icon-search1"></i>
            </div>    
        `;
    };

    async getHeadingText() {

        const getTextFromUsefullLinks = (await import(/* webpackPrefetch: true */ "../../../functions/get/getTextFromUsefullLinks.js")).getTextFromUsefullLinks;

        this.heading = getTextFromUsefullLinks({ usefulLinks: this.usefulLinks, hrefValue: `#${this.sectionId}` });

        // console.log("this.usefulLinks is @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ ", this.usefulLinks);
        // console.log("this.heading is ", this.heading, "and this.sectionId is ", this.sectionId);
        // console.log(" this.usefulLinksObj is ", this.usefulLinksObj, " &&&&&&&&&&&&&&&&&&&&");

        // $(`${this.sectionId} h2`).html(this.heading);
        // $(`${this.sectionId} h2`).html("hi everyone")

    };


    async getTotalNumberOfAvailableData(data = {}) {

        if (this.totalNumberOfData !== null) return this.totalNumberOfData;

        let totalNumberOfData = await this.getDataFromServer({ ...data, type: "count" });

        // totalNumberOfData = 1;

        $(`.${this.locationsItemsClass}`).attr("data-smetio-total-items", totalNumberOfData);

        if (totalNumberOfData < 7) {
            $(`.${this.filterBtnClass}`).remove();
            $(`.${this.searchBtnClass}`).remove();
        };

        return totalNumberOfData;

    };

    getFuncData() {
        return {
            table: this.table,
            filters: this.filters,
            language: this.language,
            appUserInterface: this.appUserInterface,
            // businessName: this.businessName,
            // country: this.country,
            smetioBnac: this.smetioBnac
        };

    };

    async getDataFromServer(data = {}) {

        let { table, filters, language, appUserInterface, url, type } = data;

        const axios = (await import(/* webpackPrefetch: true */ "axios")).default;

        // const filters = this.filters;

        url = url || `${window.apiEndPoint}/apps/${appUserInterface}/${table}/${type}/${language}`;
            
        const publicAccessToken = this.publicAccessToken;

        const res = await axios.get(url, { headers:{"Authorization": `Bearer ${publicAccessToken}`}, params: { ...filters } }).then(async (response) => {

            let totalNumberOfAvailableData = response.data;
              
            if (response.data.error) return window.smetioVisitor.showNotification({ type: "danger", body: [{ message: totalNumberOfAvailableData.msg }] });

            if (type !== "count") return response.data;

            // totalNumberOfAvailableData = response.data;

            // console.log("totalNumberOfAvailableData ", totalNumberOfAvailableData);

            // if (totalNumberOfAvailableData.error) return window.smetioVisitor.showNotification({ type: "danger", body: [{ message: totalNumberOfAvailableData.msg }] });

            return parseInt(totalNumberOfAvailableData.msg);

        }).catch((error) => {

            console.log(error);
            // this.smetioAppUi.sideMenu.dataGroups[table].preloader.hide();
            return window.smetioVisitor.showNotification({ type: "danger", body: [{ message: "txt423" }] });

        }).finally(() => {

        });

        return res;
    };

        async showOnSmartBox(data = {}) {
      
        const { content, title, position = "fixed" } = data;

        if (this.smetioSmartBox && this.smetioSmartBox.status !== "close") {
            this.smetioSmartBox.reactivate({ newHeight: "100vh", newWidth: "350px" });
            this.smetioSmartBox.updateTitle(title);
            this.smetioSmartBox.updateContent(content);
            this.smetioSmartBox.lock();
            return true;
        };       
        
        const { SmetioSmartbox }= (await import(/* webpackPrefetch: true */ "../../smetioSmartbox/v1.0.0/SmetioSmartbox.js"));

        this.smetioSmartBox = new SmetioSmartbox();

        this.smetioSmartBox.position = position;
        this.smetioSmartBox.title = title;
        this.smetioSmartBox.content = content;
        this.smetioSmartBox.onClose = () => { this.smetioSmartBox = null; };
        this.smetioSmartBox.render();  
        this.smetioSmartBox.lock();

    };

};
